class LikeButton extends HTMLElement {

  connectedCallback() {
    this.likeCount = this.querySelector('[data-like-count]');
    this.id = this.dataset.id;

    this.type = this.dataset.type ?? 'post';

    this.getLikes();

    this.addEventListener("click", () => {
      this.disabled = true; // Prevent double clicking spam
      this.saveLike();
    });
  }

  getLikes() {

    let action = 'get_post_like';
    if ('story' === this.type) {
      action = 'get_story_like';
    }

    // Fetch current likes on page load
    fetch(`/api.php?action=${action}&slug=${this.id}`)
      .then(res => res.json())
      .then(data => {
        this.likeCount.textContent = data.likes;
      });
  }

  saveLike() {

    let action = 'save_post_like';
    if ('story' === this.type) {
      action = 'save_story_like';
    }

    fetch(`/api.php?action=${action}&slug=${this.id}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ slug: this.id })
    })
      .then(res => res.json())
      .then(data => {
        if (data.likes !== undefined) {
          this.likeCount.textContent = `${data.likes}`;
        }
      })
      .catch(err => {
        console.error("Error processing like:", err);
        this.disabled = false;
      });
  }
}

customElements.define('like-button', LikeButton);